import {
  SIGNIN_SUCCESS,
  SIGNIN_FAILURE,
  LOGOUT_SUCCESS,
  ACCEPT_CONTRACT_SUCCESS,
  ACCEPT_CONTRACT_FAILURE,
} from "../../constants/actionTypes";

const INITIAL_STATE = { session: !!sessionStorage.getItem("eRecuperadorJwt") };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIGNIN_SUCCESS:
      return { ...state };
    case SIGNIN_FAILURE:
      return false;
    case LOGOUT_SUCCESS:
      return { ...state };
    case ACCEPT_CONTRACT_SUCCESS:
      return { ...state };
    case ACCEPT_CONTRACT_FAILURE:
      return { ...state, status: action.payload };
    default:
      return state;
  }
};
